import { z } from 'zod';
import { lineSchema } from './lineSchema';
import { reactionProductSchema } from './reactionProductSchema';
import { referenceSchema } from './referenceSchema';

export const overlayLeftReactionSchema = z.object({
  id: z.number(),
  notes: z.string(),
  idReaction: z.string(),
  name: z.string(),
  reversible: z.boolean(),
  symbol: z.null(),
  abbreviation: z.null(),
  formula: z.null(),
  mechanicalConfidenceScore: z.null(),
  lowerBound: z.null(),
  upperBound: z.null(),
  subsystem: z.null(),
  geneProteinReaction: z.null(),
  visibilityLevel: z.string().nullable(),
  z: z.number(),
  synonyms: z.array(z.unknown()),
  model: z.number(),
  kinetics: z.record(z.unknown()).nullable(),
  line: lineSchema,
  processCoordinates: z.null(),
  modifiers: z.array(reactionProductSchema),
  reactants: z.array(reactionProductSchema),
  products: z.array(reactionProductSchema),
  elementId: z.string(),
  operators: z.array(z.unknown()),
  references: z.array(referenceSchema),
  sboTerm: z.string(),
});
